<template>
  <div class="home">
    <page-content>
      <div class="row">
        <div class="offset-md-1 col-md-10">
          <ntm-block>
            <div class="mb-4">
              <button @click="filter = 'last5hours'" :class="{'btn-info': filter === 'last5hours'}" class="btn mr-2">Last 5 hours</button>
              <button @click="filter = 'today'" :class="{'btn-info': filter === 'today'}" class="btn mr-2">Today's games</button>
              <button @click="filter = 'last7days'" :class="{'btn-info': filter === 'last7days'}" class="btn">Last 7 days</button>
            </div>
            <div class="position-relative" style="min-height: 300px">
              <le-loading v-if="isLoading"></le-loading>
              <div v-else>
                <div v-if="venues.length > 1" class="mb-3">
                  <multiselect
                    class="w-auto"
                    style="max-width: 400px"
                    :multiple="false"
                    :placeholder="$t('venue.all')"
                    :custom-label="(option) => option.name"
                    v-model="venueFilter"
                    :options="venues"
                  ></multiselect>
                </div>
                <table v-if="filteredGames.length" class="table table-bordered table-striped table-vcenter">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Time</th>
                    <th>Game</th>
                    <th>League</th>
                    <th>{{ $tc('venue.name', 1) }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="game in filteredGames" :key="game.uuid" :class="gameStatusColor(game.status)">
                    <td>
                      <div class="d-flex flex-column align-items-start">
                        <button class="btn btn-info btn-sm mb-1 text-left" @click="goToGameGallery(game)">
                          <i class="fa fa-image mr-1"></i> {{ $t('game.gamePhotos') }}
                          <span :class="{'badge-success': game.photosCount, 'badge-warning': !game.photosCount}" class="badge ml-1">{{ game.photosCount }}</span>
                        </button>
                        <button class="btn btn-info btn-sm text-left" @click="goToGamePlayers(game)">
                          <i class="fa fa-users mr-1"></i> {{ $t('game.playerPhotos') }}
                        </button>
                      </div>
                    </td>
                    <td>{{ $gameTime(game.time, 'dateLong') }}</td>
                    <td><strong>{{ game.teamA?.name ?? '?' }}</strong> :
                      <strong>{{ game.teamB?.name ?? '?' }}</strong>
                    </td>
                    <td>{{ game.schedule.name }}</td>
                    <td>{{ game.venue?.name ?? '-' }}</td>
                  </tr>
                  </tbody>
                </table>
                <div v-else class="text-center">
                  <h4>There is no scheduled games found</h4>
                </div>
              </div>
            </div>
          </ntm-block>
        </div>
      </div>

    </page-content>
  </div>
</template>
<script>
import { gameStatusColor } from '@/lib/status'
import GamePhotosService from '@/services/gamePhotos.service'
import { useRouteQuery } from '@/use/useRouteQuery'
import LeLoading from '@/components/le/LeLoading.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: { LeLoading, Multiselect },
  data () {
    return {
      isLoading: false,
      venueFilter: null,
      model: {
        games: []
      }
    }
  },
  setup () {
    const filter = useRouteQuery('filter', 'last5hours')

    return {
      filter
    }
  },
  mounted () {
    document.addEventListener('visibilitychange', this.fetchData)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.fetchData)
  },
  beforeRouteEnter (to, from, next) {
    const filter = to.query.filter || 'last5hours'

    GamePhotosService.index(filter).then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  computed: {
    venues () {
      const venues = new Map()
      this.model.games.forEach((game) => {
        if (game.venue?.uuid) venues.set(game.venue.uuid, game.venue)
      })
      return [...venues.values()]
    },
    filteredGames () {
      if (!this.venueFilter) return this.model.games
      return this.model.games.filter((game) => game.venue?.uuid === this.venueFilter.uuid)
    }
  },
  watch: {
    filter () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.isLoading = true
      GamePhotosService.index(this.filter).then((response) => {
        this.setData(response.data)
      }).finally(() => {
        this.isLoading = false
      })
    },
    goToGameGallery (game) {
      this.$router.push({
        name: 'gameGallery',
        params: { game: game.uuid }
      })
    },
    goToGamePlayers (game) {
      this.$router.push({
        name: 'gameGallery',
        params: { game: game.uuid },
        query: { tab: 'players' }
      })
    },
    gameStatusColor,
    setData (data) {
      this.model = data
      if (this.venueFilter && !this.venues.some((venue) => venue.uuid === this.venueFilter.uuid)) {
        this.venueFilter = null
      }
    }
  }
}
</script>
